/**
 * The verdict at the rail's foot (Figma 2:2, 3:82; 4:2, 4:180): `VerdictBar` is the row of block buttons and the
 * footnote under it. The buttons are `ActionButton`s (the caller picks the look and the letter); the footnote says
 * what a verdict files.
 */
import type { ReactNode } from 'react';
import { SPACE, TEXT, usePalette } from '../theme';

export function VerdictBar({ children, note }: { children: ReactNode; note: ReactNode }) {
  const p = usePalette();
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: SPACE.snug, flexShrink: 0, padding: `${SPACE.cozy}px ${SPACE.wide}px`, borderTop: `1px solid ${p.hairline}` }}>
      <div style={{ display: 'flex', gap: SPACE.sm, alignItems: 'flex-start' }}>{children}</div>
      <p style={{ margin: 0, fontSize: TEXT.caption, color: p.inkMuted, lineHeight: 'normal' }}>{note}</p>
    </div>
  );
}
